
<!--Page 1 - Introduction-->

<template>
  <div class="page7 animated fadeIn" v-if="items">
    <img src="media/page7/trophy.png"/>
    <div class="text">
      <img src="media/page7/congrats.png"/>
      <p v-html="items.final" class="animated fadeIn"></p>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    items() {
      return this.$store.state.items
    }
  },

  methods: {
    checkCue() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      // var self = this
      // if(Math.floor(self.$refs.audio1.currentTime) == 3){
      //   self.vis1 = "visible"
      // }
    },
    runInterval() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      this.interval = setInterval(this.checkCue, 100);
    }
  },
  mounted() {
    //JIRA POSITIONING
    this.$store.commit("scormLMS/changeUserLocation", "MA KPIs: Page 7");
    this.$store.commit('contFalse');
    this.$store.commit('backTrue');
    this.$store.commit('replayFalse');

    this.$store.commit("scormLMS/scormScore", 100);
    this.$store.commit("scormLMS/scormComplete");

    setTimeout(() => {

    }, 50);

  },
  beforeDestroy() {
    //BOILERPLATE FOR RUNNING AN INTERVAL
    clearInterval(this.interval);
  },
  components: {},
  props: []
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Page7.vue?5bacafb1